import styled from 'styled-components';
import { Group, Carousel, spacing, Heading, zIndex } from '@landr/maestro';

export const scrollMenuItemClass = 'scroll-menu-item';

export const Container = styled(Group.Item)`
    width: 100%;
    position: relative;
    display: block;
`;

export const CarouselHeader = styled(Group)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: ${spacing('xl')};

    ${({ theme }): string => theme.breakpoint('md')`
        flex-direction: column;
        align-items: left;
    `}
`;

export const GenericCarouselHeading = styled(Heading)`
    display: inline-block;
    margin-bottom: 0;
`;

export const GenericCarouselStyled = styled(Carousel)`
    ${({ theme }): string => theme.breakpoint('md')`
        > div:after {
            z-index: ${zIndex('subOverlay')};
            min-width: ${spacing('xl')}; 
        }
    `}
`;
